module.exports = __webpack_public_path__ + "img/276.4326d0ca.png";